'use client';

import { HandDrawnArrow } from '@/app/[lang]/(oppl)/operations/HandDrawnArrow';

import { ModulesMessage } from './ModulesMessage';

export default function Home() {
  return (
    <div className="bg-bg h-full min-h-screen p-4 dark:text-white">
      <div className="bg-grp h-full rounded p-4 shadow">
        <div className="mx-8 flex translate-y-36 gap-4">
          <HandDrawnArrow className="shrink-0" />
          <ModulesMessage />
        </div>
      </div>
    </div>
  );
}
